import { ViewClearanceFormModal } from "../view-clearance-form-modal/view-clearance-form-modal.tsx";

export interface ViewResignationFormModalProps {
    open: boolean;
    onClose: () => void;
    offboardingId: number;
}

export function ViewResignationFormModal({
    open,
    onClose,
    offboardingId,
}: ViewResignationFormModalProps) {
    return (
        <ViewClearanceFormModal
            open={open}
            onClose={onClose}
            offboardingId={offboardingId}
            sectionType="RESIGNATION"
            title="Offboarding Request Form"
        />
    );
}
